import { render } from "./CaptchaInput.vue?vue&type=template&id=03fcb2a4"
import script from "./CaptchaInput.vue?vue&type=script&lang=js"
export * from "./CaptchaInput.vue?vue&type=script&lang=js"

import "./CaptchaInput.vue?vue&type=style&index=0&id=03fcb2a4&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__